// Namensraum "flextime": Gleitzeitkonto
const flextime = {
  'flextime.title': 'Gleitzeitkonto',
  'flextime.period': '{from} bis {to}',
  'flextime.balance': 'Saldo',
  'flextime.worked': 'Geleistet',
  'flextime.target': 'Soll',
  'flextime.targetDetail': '{days} Arbeitstage à {hours} Std.',
  'flextime.fzt': 'FZT-Minusstunden',
  'flextime.fztDetail': '{days} FZT-Tage',
  'flextime.excluded': 'Ohne Soll (Urlaub/Krankheit): {days} Tage',
  'flextime.hint': 'Saldo = geleistete Stunden − Soll. Jeder FZT-Tag zählt als Minusstunden in Höhe des Tages-Solls.',
  'flextime.hoursUnit': 'Std.',
  'flextime.error': 'Gleitzeitkonto konnte nicht geladen werden.',
};

export default flextime;
